import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import get from 'common/tools/objects/get';

import {
  markAsSeen as _markAsSeen,
  unmarkAsSeen as _unmarkAsSeen
} from 'website/actions/SocialActionActions';
import AuthenticatedLink from 'website/components/user/AuthenticatedLink';
import { getSeenItForEntity } from 'website/reducers/data/helper';

class SeenItButton extends Component {
  constructor(props) {
    super(props);
    this.toggleSeenit = this.toggleSeenit.bind(this);
  }

  toggleSeenit() {
    const { unmarkAsSeen, markAsSeen, entity } = this.props;

    let trakingEntity = { ...entity };

    // we need to keep the entity type for tracking
    // if entity is series_season or series_episode
    // we override series title and id only
    if (this.props.baseEntity) {
      trakingEntity = {
        ...trakingEntity,
        title: this.props.baseEntity.title,
        legacyId: this.props.baseEntity.legacyId
      };
    }

    if (this.props.seen) {
      return unmarkAsSeen(this.props.entity, {
        entity: trakingEntity,
        socialActionPlacement: 'standalone'
      });
    }
    return markAsSeen(this.props.entity, {
      entity: trakingEntity,
      socialActionPlacement: 'standalone'
    });
  }

  render() {
    const { className, text, seen } = this.props;
    const buttonClass = classNames(
      className,
      { active: seen },
      seen ? 'icon-tick' : 'icon-eye'
    );

    return (
      <AuthenticatedLink className={buttonClass} onClick={this.toggleSeenit}>
        {text && text.length ? <span className="txt">{text}</span> : null}
      </AuthenticatedLink>
    );
  }
}

SeenItButton.propTypes = {
  baseEntity: PropTypes.shape({
    title: PropTypes.string,
    legacyId: PropTypes.number
  }),
  user: PropTypes.shape({
    loggedIn: PropTypes.bool.isRequired
  }).isRequired,
  entity: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    typename: PropTypes.string
  }).isRequired,
  seen: PropTypes.bool,
  markAsSeen: PropTypes.func.isRequired,
  unmarkAsSeen: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

SeenItButton.defaultProps = {
  baseEntity: undefined,
  seen: false
};

const mapStateToProps = (state, ownProps) => {
  const { entityId } = ownProps;
  const entity = state.data.all[entityId];
  const seenIt = !!getSeenItForEntity(entityId, state.data);
  return {
    user: state.user,
    entity: entity,
    baseEntity: ownProps.baseEntityId
      ? get(state, ['data', 'all', ownProps.baseEntityId])
      : undefined,
    seen: seenIt
  };
};

const mapDispatchToProps = dispatch => ({
  markAsSeen: (...args) => dispatch(_markAsSeen(...args)),
  unmarkAsSeen: (...args) => dispatch(_unmarkAsSeen(...args))
});

export default connect(mapStateToProps, mapDispatchToProps)(SeenItButton);
